module.exports = __webpack_public_path__ + "img/佛手.5750faa4.jpg";